import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import SponsorshipCTA from './SponsorshipCTA';

const getCurrentRoute = () => {
  const hash = window.location.hash || '';
  if (hash.startsWith('#/')) {
    return hash.slice(1).split('?')[0] || '/';
  }
  return window.location.pathname || '/';
};

const sourceForLink = (href, route) => {
  if (href.includes('/academy-registration')) {
    if (route === '/') return { key: 'academy', source: 'home_academy_cta' };
    if (route === '/academy') return { key: 'academy', source: 'academy_page_cta' };
    return { key: 'academy', source: 'site_academy_registration_link' };
  }

  if (href.includes('/contact')) {
    if (route === '/') return { key: 'contact', source: 'home_contact_cta' };
    return { key: 'contact', source: 'site_contact_link' };
  }

  return null;
};

export default function PublicLayout() {
  useEffect(() => {
    const captureFormSource = (event) => {
      const link = event.target?.closest?.('a[href]');
      if (!link) return;

      const href = link.getAttribute('href') || '';
      const sourceInfo = sourceForLink(href, getCurrentRoute());
      if (!sourceInfo) return;

      window.sessionStorage.setItem(`aox1234_form_source_${sourceInfo.key}`, sourceInfo.source);
    };

    document.addEventListener('click', captureFormSource, true);
    return () => document.removeEventListener('click', captureFormSource, true);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 font-greek">
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />

      <div className="fixed bottom-4 right-4 z-40 sm:bottom-6 sm:right-6">
        <SponsorshipCTA
          sourceLocation="sitewide_floating"
          variant="compact"
          label="Στήριξε την ομάδα"
          className="px-4 py-3 text-sm sm:px-5 sm:text-base shadow-2xl"
        />
      </div>
    </div>
  );
}
